module.exports = __webpack_public_path__ + "img/IMG_9921.187fd241.jpg";